/**
 * Created by valerasiestov on 27.10.15.
 */

if (!window.module) {
    window.module = {};
}

module.popup = (function () {
    "use strict";

    var list = {},
        templates = {};

    function Popup(params) {
        var self = this,
            controls = {
                ready: false,
                queue: []
            },
            handlers = {
                checkQueue: function () {
                    var q = controls.queue,
                        count = q.length,
                        i;

                    for (i = 0; i < count; i++) {
                        if (typeof q[i] === 'function') {
                            q[i]();
                        }
                    }
                },

                preparePopupAnimate: function (popup, transitionElement, fullFill) {
                    var computedStyle,
                        transitionFunction = function (event) {

                            if (event.target !== transitionElement) {
                                return;
                            }

                            popup.classList.remove('animate');
                            transitionElement.removeEventListener('animationend', transitionFunction, false);
                            transitionElement.removeEventListener('webkitAnimationEnd', transitionFunction, false);

                            fullFill({
                                dom: popup
                            });

                        };

                    popup.classList.add('active');
                    computedStyle = getComputedStyle(transitionElement);

                    if (parseFloat(computedStyle.animationDuration) !== 0) {
                        popup.classList.add('animate');
                        transitionElement.addEventListener('animationend', transitionFunction, false);
                        transitionElement.addEventListener('webkitAnimationEnd', transitionFunction, false);

                        return true;
                    }

                    return false;

                },

                addEvents: function (popup) {
                    var closeButtonList = popup.querySelectorAll('[popup-close]'),
                        clickEvents = popup.querySelectorAll('[data-click]'),
                        count = clickEvents.length,
                        i;

                    for (i = 0; i < count; i++) {
                        clickEvents[i].addEventListener('click', handlers.clickEventsHandler, false);
                    }

                    count = closeButtonList.length;

                    for (i = 0; i < count; i++) {
                        closeButtonList[i].addEventListener('click', handlers.hide, false);
                    }

                },

                clickEventsHandler: function (event) {
                    if (!params.handlers) {
                        return;
                    }

                    var funcName = this.getAttribute('data-click'),
                        handler = params.handlers[funcName];

                    if (!handler || typeof handler !== 'function') {
                        return;
                    }

                    handler.call(self, event, controls.popup);
                },

                removeEvents: function (popup) {
                    var closeButtonList = popup.querySelectorAll('[popup-close]'),
                        clickEvents = popup.querySelectorAll('[data-click]'),
                        count = closeButtonList.length,
                        i;

                    for (i = 0; i < count; i++) {
                        closeButtonList[i].removeEventListener('click', handlers.hide, false);
                    }

                    count = clickEvents.length;

                    for (i = 0; i < count; i++) {
                        clickEvents[i].removeEventListener('click', handlers.clickEventsHandler, false);
                    }
                },

                hide: function () {
                    return new Promise(function (fullFill, reject) {
                        var popup = controls.popup,
                            computedStyle,
                            complete = function () {

                                if (popup) {
                                    popup.parentNode.removeChild(popup);
                                    delete controls.popup;
                                } else {
                                    return;
                                }

                                handlers.removeEvents(popup);

                                if (params.afterClose) {
                                    params.afterClose();
                                }

                                fullFill({
                                });
                            },
                            transitionFunction = function (event) {

                                if (event.target !== controls.transitionElement) {
                                    return;
                                }

                                popup.classList.remove('animate');
                                popup.classList.remove('active');
                                popup.removeEventListener('animationend', transitionFunction, false);
                                popup.removeEventListener('webkitAnimationEnd', transitionFunction, false);
                                complete();
                            },
                            animation = false;

                        computedStyle = getComputedStyle(controls.transitionElement);

                        if (parseFloat(computedStyle.animationDuration) !== 0) {
                            popup.addEventListener('animationend', transitionFunction, false);
                            popup.addEventListener('webkitAnimationEnd', transitionFunction, false);
                            animation = true;
                        }

                        popup.classList.add('animate');
                        popup.classList.remove('show');

                        if (!animation) {
                            complete();
                        }

                    });
                },

                showPopup: function (fullFill) {
                    var clone = controls.template.cloneNode(true),
                        popup = clone.firstChild,
                        animation,
                        transitionElement;

                    document.body.appendChild(clone);

                    if (params.transitionElement) {
                        transitionElement = popup.querySelector(params.transitionElement);
                    } else {
                        transitionElement = popup;
                    }

                    animation = handlers.preparePopupAnimate(popup, transitionElement, fullFill);
                    handlers.addEvents(popup);

                    if (params.beforeShow) {
                        params.beforeShow(popup);
                    }

                    controls.popup = popup;
                    controls.transitionElement = transitionElement;
                    popup.classList.add('show');

                    if (!animation) {
                        fullFill({
                            dom: popup
                        });
                    }

                },

                show: function () {

                    return new Promise(function (fullFill, reject) {

                        if (!controls.ready) {
                            controls.queue.push(function () {
                                handlers.showPopup(fullFill);
                            });

                            return;
                        }

                        handlers.showPopup(fullFill);

                    });
                }
            };

        function setConfig() {

        }

        function setEventList() {
            self.show = handlers.show;
            self.hide = handlers.hide;
        }

        function getControls() {

            function templateProcessing(template) {
                if (!template) {
                    return;
                }

                var div = document.createElement('div'),
                    fragment = document.createDocumentFragment();

                div.innerHTML = template;

                controls.link = div.firstElementChild;

                while (div.firstElementChild) {
                    fragment.appendChild(div.firstElementChild);
                }

                controls.template = fragment;

                controls.ready = true;

                handlers.checkQueue();
            }

            if (!templates[params.url]) {
                fetch(params.url).then(function (response) {

                    if (response.status < 400) {
                        return response.text();
                    }

                }).then(function (template) {

                    templateProcessing(template);

                }).catch(function (error) {
                    console.log(error);
                });
            } else {
                templateProcessing(templates[params.url]);
            }

        }

        function init() {
            getControls();
            setConfig();
            setEventList();
        }

        init();

    }

    function show(data) {
        if (list[data.url]) {
            return list[data.url].show();
        } else {
            list[data.url] = new Popup(data);
            return list[data.url].show();
        }
    }

    function hide(url) {

        if (list[url]) {
            return list[url].hide();
        }

    }

    function fetchTemplates() {
        var list = document.querySelectorAll('[data-url]'),
            count = list.length,
            i,
            fetchFunc = function (link) {
                fetch(link).then(function (response) {
                    return response.text();
                }).then(function (template) {
                    templates[link] = template;
                });
            };

        for (i = 0; i < count; i++) {
            fetchFunc(list[i].getAttribute('data-url'));
        }
    }

    return {
        show: show,
        hide: hide,
        fetchTemplates: fetchTemplates
    }

}());

window.addEventListener('DOMContentLoaded', function () {
    //module.popup.fetchTemplates();
}, false);